import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase credentials! Check your environment variables.");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export type { User } from '@supabase/supabase-js';